document.addEventListener("DOMContentLoaded", function(){
  $('.alert.alert-dismissible').on('closed.bs.alert', function () {
    var whichAlert = $(this).data('whichalert') || 'global';
    document.cookie = 'AlertDismissed--'+whichAlert+'=1;Path=/;SameSite=Lax';
  })
});
